module.exports = __webpack_public_path__ + "assets/fonts/earth-1.8fab28ac.svg";